import { ReactElement } from 'react';
import { electronBridge } from '../electron-bridge/electron-bridge';
import {
    CadNextActionHandlerContextValue,
    ActionBroadcasterContext,
} from './action-broadcaster-context';
import { actionBroadcaster } from './action-broadcaster-instance';

const contextValue: CadNextActionHandlerContextValue = {
    ack: (action, ackSource) => actionBroadcaster.ack(action, ackSource),
    trigger:
        electronBridge && 'actionBroadcasterInterface' in electronBridge
            ? electronBridge.actionBroadcasterInterface.trigger
            : electronBridge && 'actionBroadcasterTrigger' in electronBridge
            ? electronBridge.actionBroadcasterTrigger
            : (actions) => {
                  for (const action of actions) {
                      actionBroadcaster.enqueue(action.targetWindowType, action);
                  }
              },
    /**
     * Registering targets for actions locally will always target the local action queue
     * because we only need to register the window itself with electron, not sub components
     * within the window itself. When using the app on web, sub components will receive
     * actions which the window might otherwise not receive. In electron each window only receives
     * actions which specify it as the target. When running in web, all "windows" are in the same application
     * so sub components must register here to mimick the action flow and pose as "windows"
     */
    registerWindowTarget: (...args) => actionBroadcaster.registerWindowTarget(...args),
};

export function ActionBroadcasterProvider(props: { children: ReactElement }) {
    return (
        <ActionBroadcasterContext.Provider value={contextValue}>
            {props.children}
        </ActionBroadcasterContext.Provider>
    );
}
